module.exports = __webpack_public_path__ + "img/thailand.92466bfd.svg";